import { action, makeObservable, observable, runInAction } from 'mobx';
import { createFeedback } from 'api/feedback';

class FeedbackFormState {

    submitting = false;
    submitSuccess = false;

    constructor(model) {
        makeObservable(this, {
            model: false,
            submitting: observable,
            submitSuccess: observable,
            setSubmitSuccess: action.bound
        })
        this.model = model;
    }

    setSubmitSuccess(value) {
        this.submitSuccess = value;
    }

    reset = () => {
        runInAction(() => {
            this.submitting = false;
            this.submitSuccess = false;
        })
    }

    sendFeedback = async (values) => {
        runInAction(() => this.submitting = true)
        const { feedbackId } = await createFeedback(values);
        runInAction(() => this.submitting = false);
        return {
            feedbackId
        }
    }

    get submitDisabled() {
        const submitEnabled = this.acceptUserAgreement && (this.model.user.customerName || (this.model.user.customerInfo))
        return !submitEnabled;
    }

    setAcceptUserAgreement(value) {
        this.acceptUserAgreement = value
    }

}

export default FeedbackFormState;
